import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { MainContainer, OutlinedButton, PaperBox } from '../.';
import { useEnvironment } from '../contexts';
import React from 'react';
export var SidePanelLoginSuccess = function SidePanelLoginSuccess() {
    var environment = useEnvironment().environment;
    var backHome = function backHome() {
        window.location.href = environment.dashboardUrl;
    };
    return /*#__PURE__*/ _jsx(MainContainer, {
        children: /*#__PURE__*/ _jsx(PaperBox, {
            footer: /*#__PURE__*/ _jsx("div", {
                className: "flex items-center justify-between w-full",
                children: /*#__PURE__*/ _jsx(OutlinedButton, {
                    label: "Back to Home page",
                    onClick: backHome
                })
            }),
            children: /*#__PURE__*/ _jsx("div", {
                className: "flex flex-row items-center justify-between mt-8 w-full gap-4",
                children: /*#__PURE__*/ _jsxs("div", {
                    children: [
                        /*#__PURE__*/ _jsx("h1", {
                            className: "text-[var(--color-primary-success)] text-[32px] font-semibold leading-[38px] tracking-[-0.01562em] m-0 mb-2",
                            children: "Zephyr Mission Control login success!"
                        }),
                        /*#__PURE__*/ _jsx("p", {
                            children: "Zephyr Mission Control was successfully authenticated"
                        }),
                        /*#__PURE__*/ _jsx("p", {
                            className: "font-normal text-sm text-[var(--color-secondary)]",
                            children: "Now you can close this tab and return to the extension."
                        })
                    ]
                })
            })
        })
    });
};
